// extracted by mini-css-extract-plugin
export default {"container":"SmallScreenPage_container__ccCCN"};